var Modal = function() {
    var queue = [];

    var modalMap = {
        'generic-confirm-modal': ModalRendering.htmlConfirmModal,
        'generic-alert-modal': ModalRendering.htmlAlertModal,
        'sms_trial_modal': ModalRendering.htmlSMSTrialModal,
        'fqueue_premium_modal': ModalRendering.htmlFQueuePremiumModal,
        'received_history_friend_modal': ModalRendering.htmlReceivedHistoryFriendModal,
        'premium_ending_modal': ModalRendering.htmlPremiumEndingModal,
        'email_verify_modal': ModalRendering.htmlEmailVerifyModal,
        'android_promo_modal': ModalRendering.htmlPromoBanner,
        'payments_modal': ModalRendering.htmlPaymentsModal,
        'sms_payment_modal': ModalRendering.htmlSmsPaymentModal,
        'coupon_received_modal': ModalRendering.htmlCouponModal,
        'history_friend_modal': ModalRendering.htmlHistoryFriendModal
    };
    return {
        removeQueuedModal: function(modalID) {
            if (queue.length == 0) {
                return;
            }
            var index = -1;
            for (var ix = 0; ix < queue.length; ix++) {
                if (queue[ix].modalID == modalID) {
                    index = ix;
                    break;
                }
            }
            if (index >= 0) {
                queue.splice(index, 1);
            }
        },
        showModal: function(modalID, data, onRenderedCb, onCloseCb, onShownCb, forceShow) {
            Util.defaultFor(forceShow, false);
            // if we are already showing a modal, queue this one
            if ($('.modal.show').length) {
                var modalObj = {
                    'modalID' : modalID,
                    'data': data,
                    'onRenderedCb': onRenderedCb,
                    'onCloseCb': onCloseCb,
                    'onShownCb': onShownCb,
                };
                if (forceShow) {
                    // place the modal first in the queue and close the currently showing modal (to respect calling onCloseCb() if needed)
                    queue.unshift(modalObj);
                    $('.modal.show').modal('hide');
                } else {
                    queue.push(modalObj);
                }
                return;
            }
            var html = typeof modalMap[modalID] == 'function' ? modalMap[modalID](data) : '';
            if (!html) {
                return;
            }
            $('body').append(html);
            if (typeof onRenderedCb == 'function') {
                onRenderedCb();
            }

            if (typeof onShownCb == 'function') {
                $('#' + modalID).on('shown.bs.modal', function() {
                    onShownCb();
                });
            }
            $('#' + modalID).modal('show');

            $('#' + modalID).on('hidden.bs.modal', function() {
                if (typeof onCloseCb == 'function') {
                    onCloseCb();
                }
                $(this).remove();
                // show queued modal
                if (queue.length != 0) {
                    var modal = queue.shift();
                    if (modal) {
                        Modal.showModal(modal.modalID, modal.data, modal.onRenderedCb, modal.onCloseCb, modal.onShownCb);
                        // NOTE: called self to show the queued modal. Any code bellow this point won't be executed.
                    }
                    return;
                }
            });
        },
        hideModal: function(id) {
            $('#' + id).modal('hide');
        },
        showConfirmModal: function(text, onVerifyCb, title, rawBody) {
            title = Util.defaultFor(title, 'Επιβεβαίωση');
            rawBody = Util.defaultFor(rawBody, false);
            var data = {
                title: title,
                rawBody: rawBody,
                body: text
            };
            Modal.showModal(
                'generic-confirm-modal',
                data,
                function() {
                    $('#generic-confirm-ok-btn').on('click', onVerifyCb);
                }
            );
        },
        showAlertModal: function(text, onCloseCb, title, rawBody, onShownCb) {
            title = Util.defaultFor(title, 'Ειδοποίηση');
            rawBody = Util.defaultFor(rawBody, false);
            onShownCb = Util.defaultFor(onShownCb, false);
            var data = {
                title: title,
                rawBody: rawBody,
                body: text
            };
            Modal.showModal(
                'generic-alert-modal',
                data,
                null,
                function() {
                    if (typeof onCloseCb == 'function') {
                        onCloseCb();
                    }
                },
                onShownCb
            );
        },
        showFemaleRegisterModal: function() {
            Modal.showConfirmModal(
                '\
                    <div class="mx-2">\
                        Έχοντας λογαριασμό στο Blindchat θα έχεις τη δυνατότητα:\
                        <ul class="list-check mt-2">\
                            <li>να προσθέσεις στη λίστα των φίλων σου τους συνομιλητές σου για να μην χαθείτε</li>\
                            <li>να χρησιμοποιήσεις την υπηρεσία «Μιλήσαμε & Χαθήκαμε» για να βρεις άτομα από πρόσφατες συνομιλίες που έκανες (μόνο για PREMIUM)</li>\
                            <li>να χρησιμοποιήσεις την υπηρεσία «Νέες Γνωριμίες» με την οποία μπορεις να βρεις φίλους που σου αρέσουν με βάση το προφίλ τους\
                        <ul>\
                    </div>\
                ',
                function() {
                    Common.showRegisterLoginModal('migrate', false, 'register');
                },
                'Φτιάξε λογαριασμό!',
                true
            );
        }
    };
}();


if (typeof module !== 'undefined') {
    module.exports = Modal;
}
